import { route } from "../router/route";

export const menus = [
  {
    title: "금융 스터디",
    src: `${route.study_list}`,
    includeValue: `${route.study_list}`,
  },
  {
    title: "영상 강의",
    src: `${route.lecture_list}`,
    includeValue: `${route.lecture_list}`,
  },
  {
    title: "금융 칼럼",
    src: `${route.column_list}`,
    includeValue: `${route.column_list}`,
  },
  {
    title: "커뮤니티",
    src: `${route.community_list}`,
    includeValue: `${route.community_list}`,
  },
  {
    title: "1:1 컨설팅",
    src: route.consulting,
    includeValue: `${route.consulting}`,
  },
];
